export default __webpack_public_path__ + "static/media/Bronze-Bow-Necklace.58bec070.jpg";